// import { canUseDOM } from 'exenv';
import extend from 'lodash/extend';

export function micSectorLoading(resp = {}, store = {}) {
  return {
    type: 'MIC_SECTOR_LOADING',
    micSector: resp,
    store
  };
}

export function micSectorLoaded(resp = {}, store = {}, year, sector) {
  extend(resp, { year });
  return {
    type: 'MIC_SECTOR_LOADED',
    micSector: resp,
    store,
    year,
    sector
  };
}

export function micSectorLoadError(error, store = {}) {
  return {
    type: 'MIC_SECTOR_ERROR',
    micSector: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
